{
  "dropzoneLabel": "DropZone",
  "selectPlaceholder": "Выберите элемент",
  "tableResizer": "Средство изменения размера",
  "expand": "Expand",
  "collapse": "Collapse",
  "colorSwatchPicker": "Color swatches"
}
